import React from 'react';
import PermissionAccounts from '../permissions/accounts';
export default function AdminsScreen() { return <PermissionAccounts kind="user" />; }
